import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LiveLessonCard } from '@lean-body/components/organisms';
import { MediaBreakPointUp } from '@lean-body/components/styles';
export const LiveLessonList = (props) => {
    const { liveLessons, apiClient, tracker, classObject } = props;
    const onClickAttendance = (id, isAttendance) => {
        if (!isAttendance) {
            apiClient.attendLiveLesson(id);
        }
        else {
            apiClient.absentLiveLesson(id);
        }
    };
    return (React.createElement("div", { className: css(styles.container, classObject) }, liveLessons.map((live, i) => (React.createElement(LiveLessonCard, { key: i, liveLesson: live, tracker: tracker, onClickAttendance: onClickAttendance, classObject: styles.card })))));
};
const styles = StyleSheet.create({
    container: {
        [MediaBreakPointUp.XL]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, 32.5%)',
            justifyContent: 'space-between',
        },
    },
    card: {
        marginBottom: 24,
        [MediaBreakPointUp.XL]: {
            maxWidth: 335,
        },
    },
});
